import React, { Component } from 'react';
import classNames from 'classnames';

import logoImg from '../img/logo.png';

export class Logo extends Component {
  classes() {
    return classNames('logo', 'col-md-6');
  }

  render() {
    return (
      <a href="/" className={this.classes()}>
        <h1>DUKIM s.r.o.</h1>
        <div className="helper" />
        <img src={logoImg} alt="DUKIM s.r.o." />
      </a>
    );
  }
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js